import axios from 'axios';

import { baseURL } from '../config';
import { AppStorage } from './UserStorage';

type SilentAxiosConfig = {
  url?: string;
  _retried?: boolean;
};

const silentAxios = axios.create({
  baseURL,
  xsrfHeaderName: 'RequestVerificationToken',
});

const silentLogin = async () => {
  await silentAxios.post('account/login', {
    userNameOrEmailAddress: AppStorage.get('UserName'),
    password: AppStorage.get('Pass'),
    rememberMe: false,
  });
};

const retryRequest = async (originalRequest: SilentAxiosConfig) => {
  if (originalRequest._retried) {
    window.location.hash = '/login';
    return null;
  }

  try {
    await silentLogin();
    originalRequest._retried = true;
    return silentAxios(originalRequest);
  } catch {
    window.location.hash = '/login';
    return null;
  }
};

silentAxios.interceptors.response.use(
  async (response) => {
    if (response?.status === 302) {
      return (await retryRequest(response.config as SilentAxiosConfig)) ?? response;
    }

    return response;
  },
  async (error) => {
    const status = error?.response?.status;

    if (status === 0 || status === 302 || status === 401) {
      const retried = await retryRequest((error.config || {}) as SilentAxiosConfig);
      if (retried) {
        return retried;
      }
    }

    return Promise.reject(error);
  },
);

export default silentAxios;
